/* FAMALUX — interactions partagées */
(function () {
  // --- Menu mobile ---
  const toggle = document.querySelector('.menu-toggle');
  const drawer = document.querySelector('.mnav');
  const close  = document.querySelector('.mnav-close');
  if (toggle && drawer) {
    toggle.addEventListener('click', () => { drawer.classList.add('open'); document.body.style.overflow = 'hidden'; });
  }
  if (close && drawer) {
    const shut = () => { drawer.classList.remove('open'); document.body.style.overflow = ''; };
    close.addEventListener('click', shut);
    drawer.querySelectorAll('nav a').forEach(a => a.addEventListener('click', shut));
  }

  // --- Reveal au scroll ---
  // Les éléments plus hauts que ~50% du viewport n'atteignent jamais 12% de
  // visibilité (ex. corps d'article de blog) : seuil 0 pour eux.
  const onReveal = (entries, o) => {
    entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); o.unobserve(e.target); } });
  };
  const obs = new IntersectionObserver(onReveal, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
  const obsTall = new IntersectionObserver(onReveal, { threshold: 0, rootMargin: '0px 0px -8% 0px' });
  document.querySelectorAll('.reveal').forEach(el => {
    (el.offsetHeight > window.innerHeight * 0.5 ? obsTall : obs).observe(el);
  });

  // (panier géré par la buybox Shopify — voir IIFE buybox ci-dessous)

  // --- Accordéon FAQ ---
  document.querySelectorAll('.faq-item').forEach(item => {
    const q = item.querySelector('.faq-q');
    q.addEventListener('click', () => {
      const open = item.classList.contains('open');
      document.querySelectorAll('.faq-item.open').forEach(o => { if (o !== item) o.classList.remove('open'); });
      item.classList.toggle('open', !open);
    });
  });

  // --- Galerie produit (miniatures) ---
  document.querySelectorAll('[data-gallery]').forEach(g => {
    const main = g.querySelector('[data-gallery-main]');
    g.querySelectorAll('[data-thumb]').forEach(t => {
      t.addEventListener('click', () => {
        g.querySelectorAll('[data-thumb]').forEach(x => x.classList.remove('active'));
        t.classList.add('active');
        const src = t.getAttribute('data-thumb');
        if (src && main) main.style.backgroundImage = `url('${src}')`;
      });
    });
  });


})();

// Buybox: selettore tier + aggiunta carrello Shopify
(function () {
  var tiersWrap = document.getElementById('tiers');
  if (!tiersWrap) return;
  var tiers = tiersWrap.querySelectorAll('.tier');
  var totalEl = document.getElementById('bb-total');
  var addBtn = document.querySelector('[data-add-cart]');
  var errEl = document.querySelector('[data-cart-error]');
  var selected = tiersWrap.querySelector('.tier.active') || tiers[0];
  if (selected) {
    selected.classList.add('active');
    if (totalEl && selected.getAttribute('data-price')) totalEl.textContent = selected.getAttribute('data-price');
  }

  // Galerie : slider photos produit (swipe + flèches + miniatures)
  var track = document.getElementById('bb-track');
  var thumbsWrap = document.getElementById('bb-thumbs');
  var prevBtn = document.getElementById('bb-prev');
  var nextBtn = document.getElementById('bb-next');
  var colorsWrap = document.getElementById('bb-colors');
  var currentVariant = tiersWrap.getAttribute('data-variant-id');

  function bindColor(onPick) {
    if (!colorsWrap) return;
    colorsWrap.querySelectorAll('.bb-color').forEach(function (btn) {
      btn.addEventListener('click', function () {
        colorsWrap.querySelectorAll('.bb-color').forEach(function (x) { x.classList.remove('active'); });
        btn.classList.add('active');
        currentVariant = btn.getAttribute('data-variant');
        if (onPick) onPick(btn);
      });
    });
  }

  if (track) {
    var slides = track.querySelectorAll('.bb-slide');
    var slideCount = slides.length;
    var currentIndex = 0;

    function syncUI() {
      if (thumbsWrap) {
        thumbsWrap.querySelectorAll('.bb-thumb').forEach(function (th, i) {
          th.classList.toggle('active', i === currentIndex);
        });
      }
      if (prevBtn) prevBtn.disabled = currentIndex <= 0;
      if (nextBtn) nextBtn.disabled = currentIndex >= slideCount - 1;
    }

    function goTo(index, instant) {
      index = Math.max(0, Math.min(slideCount - 1, index));
      currentIndex = index;
      track.scrollTo({ left: track.clientWidth * index, behavior: instant ? 'auto' : 'smooth' });
      syncUI();
    }

    function slideIndexForImage(src) {
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-image') === src) return i;
      }
      return -1;
    }

    var scrollTimer;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var w = track.clientWidth;
        if (!w) return;
        currentIndex = Math.round(track.scrollLeft / w);
        syncUI();
      }, 100);
    });

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(currentIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(currentIndex + 1); });

    if (thumbsWrap) {
      thumbsWrap.querySelectorAll('.bb-thumb').forEach(function (th) {
        th.addEventListener('click', function () {
          goTo(parseInt(th.getAttribute('data-index'), 10) || 0);
        });
      });
    }

    // Variante colore → scorre alla foto della variante
    bindColor(function (btn) {
      var idx = slideIndexForImage(btn.getAttribute('data-image'));
      if (idx >= 0) goTo(idx);
    });

    // État initial : couleur active + photo correspondante
    var activeColor = colorsWrap && (colorsWrap.querySelector('.bb-color.active') || colorsWrap.querySelector('.bb-color'));
    if (activeColor) {
      currentVariant = activeColor.getAttribute('data-variant');
      var initIdx = slideIndexForImage(activeColor.getAttribute('data-image'));
      if (initIdx > 0) goTo(initIdx, true);
    }
    syncUI();
  } else {
    // Fallback sans slider (0/1 photo) : seule la sélection de variante
    bindColor(null);
  }

  tiers.forEach(function (t) {
    t.addEventListener('click', function () {
      tiers.forEach(function (x) { x.classList.remove('active'); });
      t.classList.add('active');
      selected = t;
      if (totalEl) totalEl.textContent = t.getAttribute('data-price') || totalEl.textContent;
    });
  });

  function refreshCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = c.item_count;
          el.style.opacity = c.item_count > 0 ? '1' : '0';
        });
      })
      .catch(function () {});
  }

  if (addBtn) addBtn.addEventListener('click', function (e) {
    e.preventDefault();
    if (errEl) { errEl.style.display = 'none'; errEl.textContent = ''; }
    var variantId = currentVariant || tiersWrap.getAttribute('data-variant-id');
    var qty = parseInt((selected && selected.getAttribute('data-qty')) || '1', 10);
    if (!variantId) { if (errEl) { errEl.style.display = 'block'; errEl.textContent = 'Produit indisponible.'; } return; }
    addBtn.setAttribute('aria-busy', 'true');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: qty })
    })
      .then(function (r) { if (!r.ok) { return r.json().then(function (j) { throw new Error(j.description || 'Erreur'); }); } return r.json(); })
      .then(function () {
        if (window.FamaluxCart) { window.FamaluxCart.open(); }
        else { refreshCount(); window.location.href = '/cart'; }
      })
      .catch(function (err) { if (errEl) { errEl.style.display = 'block'; errEl.textContent = err.message; } })
      .finally(function () { addBtn.removeAttribute('aria-busy'); });
  });

  refreshCount();
})();

// Accordion (Dès la première nuit)
(function () {
  document.querySelectorAll('.acc-item').forEach(function (item) {
    var q = item.querySelector('.acc-q');
    if (!q) return;
    q.addEventListener('click', function () {
      var open = item.classList.contains('open');
      document.querySelectorAll('.acc-item.open').forEach(function (o) { if (o !== item) o.classList.remove('open'); });
      item.classList.toggle('open', !open);
    });
  });
})();

// Anteprima panier — cart drawer (mini-cart)
(function () {
  var drawer = document.getElementById('cart-drawer');
  if (!drawer) return;
  var body = drawer.querySelector('[data-cart-body]');
  var foot = drawer.querySelector('[data-cart-foot]');
  var subEl = drawer.querySelector('[data-cart-subtotal]');
  var shipEl = drawer.querySelector('[data-cart-shipmsg]');
  var productUrl = drawer.getAttribute('data-product-url') || '/';
  var busy = false;

  function money(c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  function open() { drawer.classList.add('open'); drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
  function close() { drawer.classList.remove('open'); drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
  function updateCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; el.style.opacity = n > 0 ? '1' : '0'; });
  }

  function render(cart) {
    updateCount(cart.item_count);
    if (!cart.items || cart.items.length === 0) {
      body.innerHTML = '<div class="cart-empty"><p>Ton panier est vide.</p><a href="' + productUrl + '" class="btn btn--light" data-cart-close>Découvrir le bonnet</a></div>';
      if (foot) foot.hidden = true;
      return;
    }
    var html = '';
    cart.items.forEach(function (it) {
      var variant = (it.variant_title && it.variant_title !== 'Default Title') ? '<span class="cart-line__variant">' + esc(it.variant_title) + '</span>' : '';
      var img = it.image ? '<img src="' + it.image + '" alt="" loading="lazy">' : '';
      html += '<div class="cart-line" data-key="' + it.key + '">'
        + '<div class="cart-line__img">' + img + '</div>'
        + '<div class="cart-line__info">'
        + '<span class="cart-line__title">' + esc(it.product_title) + '</span>'
        + variant
        + '<div class="cart-line__bottom">'
        + '<div class="cart-qty"><button type="button" data-dec aria-label="Moins">−</button><span>' + it.quantity + '</span><button type="button" data-inc aria-label="Plus">+</button></div>'
        + '<span class="cart-line__price">' + money(it.final_line_price) + '</span>'
        + '</div>'
        + '<button type="button" class="cart-line__remove" data-remove>Retirer</button>'
        + '</div></div>';
    });
    body.innerHTML = html;
    if (subEl) subEl.textContent = money(cart.total_price);
    if (shipEl) {
      if (cart.item_count >= 2) { shipEl.innerHTML = '🎉 Livraison offerte&nbsp;!'; }
      else { shipEl.textContent = 'Plus qu’un article pour la livraison offerte'; }
    }
    if (foot) foot.hidden = false;
  }

  function refresh() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); }).then(function (c) { render(c); return c; });
  }
  function change(key, qty) {
    if (busy) return; busy = true;
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json(); }).then(render)
      .catch(function () {}).finally(function () { busy = false; });
  }

  body.addEventListener('click', function (e) {
    var line = e.target.closest('.cart-line');
    if (!line) return;
    var key = line.getAttribute('data-key');
    var span = line.querySelector('.cart-qty span');
    var cur = parseInt(span ? span.textContent : '1', 10) || 1;
    if (e.target.closest('[data-inc]')) change(key, cur + 1);
    else if (e.target.closest('[data-dec]')) change(key, Math.max(0, cur - 1));
    else if (e.target.closest('[data-remove]')) change(key, 0);
  });

  drawer.addEventListener('click', function (e) { if (e.target.closest('[data-cart-close]')) close(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('open')) close(); });

  document.querySelectorAll('.cart-btn').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var m = document.querySelector('.mnav.open');
      if (m) m.classList.remove('open');
      refresh().then(open);
    });
  });

  window.FamaluxCart = { open: function () { refresh().then(open); }, refresh: refresh, close: close };
})();
